import { create } from "zustand";
import { persist } from "zustand/middleware";
import { storageKey } from "@/constants/StorageKeys";

interface RecentKeywordsStore {
  keywords: string[];
  addKeyword: (value: string) => void;
  removeKeyword: (value: string) => void;
  clearKeywords: () => void;
}

/*
 games page recent keyword 검색 store
 */
export const createRecentKeywordStore = (storageKey: string) => {
  return create<RecentKeywordsStore>()(
    persist(
      (set, get) => ({
        keywords: [],
        addKeyword: (value: string) => {
          const filtered = get().keywords.filter((k) => k !== value);
          const updated = [value, ...filtered].slice(0, 5);
          set({ keywords: updated });
        },
        removeKeyword: (value: string) => {
          set({ keywords: get().keywords.filter((k) => k !== value) });
        },
        clearKeywords: () => set({ keywords: [] }),
      }),
      {
        name: storageKey,
      },
    ),
  );
};

export const useGameKeywordStore = createRecentKeywordStore(
  storageKey.GAMES_RESENT_KEYWORD,
);
export const useAthKeywordStore = createRecentKeywordStore(
  storageKey.ATH_RESENT_KEYWORD,
);
